import React, { useContext } from 'react';
import Markdown from 'src/components/common/markdown';
import type { Styling } from 'src/context/styling';
import type { BuildType } from 'src/enums/build/build-type';
import { getFooterColors } from 'src/components/layout/footer/redesign/colors';
import type { CSSInterpolation } from '@emotion/serialize';
import { SiteContext } from 'src/context/site-context';

type CopyrightInformationProps = {
  copyrightInformation: string;
  imagesDisclaimer: string;
};

const createComponentStyling = (styling: Styling, buildType: BuildType) => {
  const footerColors = getFooterColors(buildType);
  return {
    copyrightInformation: [
      styling.fonts.regular,
      {
        'color': footerColors.text,
        'fontSize': '1rem',
        'lineHeight': '125%',
        'strong': [styling.fonts.bold],
        'p, strong': {
          '&:not(:last-child)': {
            marginBottom: '0.75rem',
          },
          '&:last-child': {
            marginBottom: 0,
          },
        },
      },
    ],
    disclaimer: [
      styling.fonts.regular,
      {
        fontSize: '1rem',
        lineHeight: '125%',
        margin: '0.75rem 0 0',
      },
    ],
  } satisfies Record<string, CSSInterpolation>;
};

const CopyrightInformation = ({
  copyrightInformation,
  imagesDisclaimer,
}: CopyrightInformationProps) => {
  const { styling, buildType, isGlobalPage } = useContext(SiteContext);
  const componentStyling = createComponentStyling(styling, buildType);
  return (
    <div>
      {copyrightInformation && (
        <Markdown
          colorOverride="unset"
          cssOverride={componentStyling.copyrightInformation}
          markdownText={copyrightInformation}
        />
      )}
      {imagesDisclaimer && !isGlobalPage && (
        <p css={componentStyling.disclaimer}>{imagesDisclaimer}</p>
      )}
    </div>
  );
};

export { CopyrightInformation };
